import React from 'react';
import { Box } from '@mui/material';
import { IStrengthBlock } from './interfaces';

export const StrengthBlock: React.FC<IStrengthBlock> = ({
  active = false,
  activeColor,
}): JSX.Element => {
  return (
    <Box
      sx={{
        borderRadius: '5px',
        height: '5px',
        backgroundColor: active ? activeColor : '#E0E3E8',
        flex: '1',
      }}
    ></Box>
  );
};
